// extracted by mini-css-extract-plugin
export default {"cls1":"eT75BqYUxiV6E0fbQ6Vu","cls2":"uynIOctYCf0eTCIIlByw eT75BqYUxiV6E0fbQ6Vu"};